/** @license ISC License (c) copyright 2016 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var VERSION = 2

var _implements = require('../core/implements')
var _inspect = require('../core/inspect')
var _equals = require('../core/equals')
var type = require('../core/types').type('Min')
var _type = require('../core/types').typeFn(type(), VERSION)
var fl = require('../core/flNames')

var isNil = require('../core/isNil')
var isNumber = require('../core/isNumber')
var isSameType = require('../core/isSameType')

var _empty =
  function () { return Min(Infinity); }

function Min(n) {
  var obj;

  var x = isNil(n) ? _empty().valueOf() : n

  if(!arguments.length || !isNumber(x)) {
    throw new TypeError('Min: Numeric value required')
  }

  var valueOf =
    function () { return x; }

  var empty =
    _empty

  var inspect =
    function () { return ("Min" + (_inspect(valueOf()))); }

  var equals =
    function (m) { return isSameType(Min, m)
      && _equals(x, m.valueOf()); }

  function concat(method) {
    return function(m) {
      if(!isSameType(Min, m)) {
        throw new TypeError(("Min." + method + ": Min required"))
      }

      return Min(Math.min(x, m.valueOf()))
    }
  }

  return ( obj = {
    inspect: inspect, toString: inspect,
    equals: equals, valueOf: valueOf, type: type, empty: empty,
    concat: concat('concat')
  }, obj[fl.equals] = equals, obj[fl.empty] = empty, obj[fl.concat] = concat(fl.concat), obj['@@type'] = _type, obj.constructor = Min, obj )
}

Min['@@implements'] = _implements(
  [ 'equals', 'concat', 'empty' ]
)

Min.empty = _empty
Min.type = type

Min[fl.empty] = _empty
Min['@@type'] = _type

module.exports = Min
